import { Dialog, DialogContent, Button, Typography, Box } from '@mui/material'

interface AccountLinkingSuccessModalProps {
  isOpen: boolean
  onComplete: () => void
}

export default function AccountLinkingSuccessModal({
  isOpen,
  onComplete,
}: AccountLinkingSuccessModalProps) {
  return (
    <Dialog open={isOpen} disableEscapeKeyDown maxWidth="sm" fullWidth>
      <DialogContent sx={{ p: 4 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 2,
            textAlign: 'center',
          }}
        >
          <Typography
            variant="h5"
            sx={{
              fontSize: '24px',
              fontWeight: 600,
              color: '#1C3045',
              mb: 1,
            }}
          >
            Accounts Linked Successfully!
          </Typography>

          <Typography
            variant="body1"
            sx={{
              fontSize: '16px',
              color: '#4a5568',
              mb: 1,
            }}
          >
            You will be redirected to the login page to complete the process.
          </Typography>

          <Typography
            variant="body2"
            sx={{
              fontSize: '14px',
              color: '#718096',
              lineHeight: 1.5,
              fontStyle: 'italic',
              mb: 2,
            }}
          >
            If you are not automatically redirected in a few seconds, please
            click the button below to log back in to your account and complete
            the process.
          </Typography>

          <Button
            variant="text"
            disableRipple
            onClick={onComplete}
            sx={{
              height: '40px',
              textTransform: 'none',
              mt: 1,
              textDecoration: 'underline',
              '&:focus': {
                backgroundColor: '#e8e8e8',
              },
            }}
          >
            Complete Linking Process
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  )
}
